import { configureStore, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ProfileModel } from '../models/person/ProfileModel'

export type MessageType = {
  message: any,
  color: string
}

export type LogState = {
  LoggedIn: boolean,
  forceRedirectLogin: boolean
}

export type AdminInfo = {
  dashboardEnable: boolean,
  hasMill: boolean
}

const adminSlice = createSlice({
  name: 'admin',
  initialState: {
    value: undefined as AdminInfo | null | undefined
  },
  reducers: {
    updateAdmin: (state, action: PayloadAction<AdminInfo>) => {
      state.value = action.payload
    },
    logout: state => {
      state.value = null
    }
  }
})

const userProfileSlice = createSlice({
    name: 'userProfile',
    initialState: {
      value: undefined as ProfileModel | null | undefined
    },
    reducers: {
        updateUserProfile: (state, action: PayloadAction<ProfileModel | null>) => {
            state.value = action.payload
        }
    }
})

const tokenSlice = createSlice({
  name: 'token',
  initialState: {
    value: undefined as string | null | undefined
  },
  reducers: {
    updateToken: (state, action: PayloadAction<string>) => {
      state.value = action.payload
    },
    logout: state => {
      state.value = null
    }
  }
})

const ErrorState: MessageType | null = null

const errorMessageSlice = createSlice({
  name: 'error_message',
  initialState: {
    value: ErrorState as MessageType | null
  },
  reducers: {
    setErrorMessageAction: (state, action: PayloadAction<MessageType>) => {
      state.value = action.payload
    }
  }
})

const pathSlice = createSlice({
  name: 'path',
  initialState: {
    value: ''
  },
  reducers: {
    setPath: (state, action: PayloadAction<string>) => {
      state.value = action.payload
    }
  }
})

const logState: LogState | null = null

const isLoggedInSlice = createSlice({
  name: 'path',
  initialState: {
    value: logState as LogState | null
  },
  reducers: {
    setIsLoggedIn: (state, action: PayloadAction<LogState|null>) => {
      state.value = action.payload
    }
  }
})

export type MenuState = {
  isMobile: boolean,
  isMenuOpen: boolean
}

const menuState: MenuState = {
  isMobile: false,
  isMenuOpen: false
}

const menuSlice = createSlice({
  name: 'menu',
  initialState: {
    value: menuState as MenuState | null
  },
  reducers: {
    setMenuState: (state, action: PayloadAction<MenuState|null>) => {
      state.value = action.payload
    }
  }
})

export const {updateToken, logout} = tokenSlice.actions
export const {setErrorMessageAction} = errorMessageSlice.actions
export const {setPath} = pathSlice.actions
export const {setIsLoggedIn} = isLoggedInSlice.actions
export const {updateAdmin} = adminSlice.actions
export const {setMenuState} = menuSlice.actions
export const { updateUserProfile } = userProfileSlice.actions

export const NFMStore = configureStore({
  reducer: {
    token: tokenSlice.reducer,
    errorMessage: errorMessageSlice.reducer,
    path: pathSlice.reducer,
    isLoggedIn: isLoggedInSlice.reducer,
    admin: adminSlice.reducer,
    menu: menuSlice.reducer,
    userProfile: userProfileSlice.reducer
  }
})